
import * as React from 'react';
import { cn } from '@/lib/utils';

/** Inline HugeIcons glyph: <Icon name="calendar-03" />. Decorative by default
 *  (aria-hidden) — an icon used as the only content should pass aria-label + role="img".
 *  leading-none + a small negative baseline shift keep the tall font glyph on the
 *  SAME LINE as the text next to it (it used to float above the sentence). */
export function Icon({
  name,
  size = 18,
  className,
  ...rest
}: { name: string; size?: number; className?: string } & React.HTMLAttributes<HTMLElement>) {
  const labelled = rest['aria-label'] != null || rest.role != null;
  return (
    <i
      aria-hidden={labelled ? undefined : true}
      {...rest}
      className={cn(
        'hgi-stroke inline-block leading-none align-[-0.125em]',
        `hgi-${name}`,
        className,
      )}
      style={{ fontSize: size, ...rest.style }}
    />
  );
}
